export class UrlParams {
    private static readonly HOST_BACKEND = [
        {
            host: 'http://localhost:4200',
            // backend: 'https://localhost:44365/Api'
            backend: 'https://cookiehunters.com/huntingapi/Api'
        },
        {
            host: 'http://cookiehunters.com',
            backend: 'http://cookiehunters.com/huntingapi/Api'
        },
        {
            host: 'https://cookiehunters.com',
            backend: 'https://cookiehunters.com/huntingapi/Api'
        }
    ];

    public static ACTIVE_HOST: string;
    private static API: string;

    public static init(host: string) {
        const hostBackend = this.HOST_BACKEND.find((hb) => host.startsWith(hb.host));
        if (!hostBackend) {
            alert(`Unknown hub ${host}`);
        } else {
            this.API = `${hostBackend.backend}`;
            this.ACTIVE_HOST = host;
        }
    }


    public static get LOGIN(): any {
        const param = `${this.API}/Home`;
        return {
            USER_LOGIN: `${param}/Login`,
            CHECK_USER: `${param}/CheckUser`,
            FORGET_PASSWORD: `${param}/ForgetPassword`,
            RESET_PASSWORD: `${param}/reset`,
            CHANGE_PASSWORD: `${param}/ChangePassword`,
            USER_REGISTRATION: `${param}/UserRegistration`
        };
    }

    public static get MASTER(): any {
        const param = `${this.API}/Master`;
        return {
            GET_MODE: `${param}/GetMode`,
            INSERT_INPUT_MASTER: `${param}/InputMaster`,
            GET_INPUT_MASTER: `${param}/GetInputMaster`,
            GET_DROPDOWN_MASTER: `${param}/getdistinctParameters`,
            GET_REVIEW_TYPE_MASTER: `${param}/GetReviewType`,
        };
    }

    public static get ADWARE(): any {
        const param = `${this.API}/Adware`;
        return {
            INSERT_ADWARE: `${param}/InsertAdware`,
            GET_PROJECT_SERVER_MAP: `${param}/ManageVmAdware`,

        };
    }


    public static get EMAIL(): any {
        const param = `${this.API}/EmailTemplate`;
        return {
            INSERT_EMAIL: `${param}/InsertEmail`,
            GET_EMAIL: `${param}/getEmailTemplateList`,
            DELETE_EMAIL: `${param}/deleteEmailNotification`,
            UPDATE_EMAIL: `${param}/updateEmailNotification`
        };
    }


    public static get PROJECT(): any {
        const param = `${this.API}/Project`;
        return {
            INSERT_PROJECT: `${param}/createProject`,
            GET_PROJECT: `${param}/GetProjectDetail`,
            INSERT_SERP_PROJECT: `${param}/InsertProjects`,
            GET_SERP_PROJECT_LIST: `${param}/GetKeywordWiseList`,
            INSERT_DOMAIN_PROJECT: `${param}/DomainWiseProject`,
            GET_DOMAIN_PROJECT_LIST: `${param}/GetDomainWiseList`,
            INSERT_DIRECTORY: `${param}/downloadDirectoryAnalysis`,
            MARK_AS_DUPLICATE: `${param}/MarkAsDuplicate`,

        };
    }
    public static get TASK(): any {
        const param = `${this.API}/Task`;
        return {
            INSERT_TASK: `${param}/InsertTask`,
            GET_TASK: `${param}/GetTaskList`,
        };
    }
    public static get DASHBOARD(): any {
        const param = `${this.API}/Dashboard`;
        return {
            GET_DASHBOARD_COUNT: `${param}/getDashboardCount`,
            GET_DASHBOARD_DETAIL: `${param}/getDashDetail`,
        };
    }
    public static get REPORT(): any {
        const param = `${this.API}/Report`;
        return {
            GET_IR_REPORT_LIST: `${param}/GetIRReportList`,
            GET_FILETYPEANALYSIS: `${param}/GetFileCountDetail`,
            GET_FILETYPE_SUMMARY: `${param}/GetfileTypeSummary`,
            GET_DOWNLOAD_DIRECTORY: `${param}/GetReviewStats`,
            GET_INTERNALREPORT: `${param}/InternalReport`,
            UPDATE_REVIEW_STATUS: `${param}/UpdateStatus`,
            GET_CSIR_REPORT: `${param}/csIrReport`,
            GET_CSIR_REPORTDETAILS: `${param}/csIRDetailReport`,
        };
    }
}